module.exports = __webpack_public_path__ + "static/media/rhino_02.3d716462.glb";